import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.iterator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
export var textConvertToMultiLine = function textConvertToMultiLine(text) {
  if (typeof text === 'string') {
    return text.split('\n').map(function (i) {
      return i.trim();
    }).reduce(function (p, n, i) {
      return [].concat(_toConsumableArray(p), [!!i && /*#__PURE__*/React.createElement("br", {
        key: String(i)
      }), n]);
    }, []);
  }

  return text;
};
export var textDivineParagraph = function textDivineParagraph(str) {
  return str.replace(/<br>/g, '<br>').split('<br>').filter(function (i) {
    return i;
  });
};
export var textNormalize = function textNormalize(str) {
  var trim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!str) {
    return '';
  }

  var text = str.replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ').replace(/<br ?\/?>/g, '\n').replace(/\s\s+/g, ' ');

  if (trim) {
    return text.trim();
  }

  return text;
};
export var textRemoveHtml = function textRemoveHtml(str) {
  return textNormalize(str, false).replace(/(<([^>]+)>)/gi, '');
};
export var textToMultiline = function textToMultiline(text) {
  return text.replace(/(\n){2,}/g, '\n').split('\n').filter(function (i) {
    return !!i;
  });
};